import React from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { useSnackbar } from 'notistack';

import { Icon } from '@iconify/react';
import editFill from '@iconify/icons-eva/edit-fill';

import {
  List,
  ListSubheader,
  ListItemText,
  ListItem,
  ListItemButton,
  IconButton,
  Stack
} from '@mui/material';

import { createWithURLSearchParams } from '../../fetch';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectGeofencesArray } from '../../createSelectorUtils';

SideBarGeofences.propTypes = {
  setSelectedGeofenceId: PropTypes.func,
  setIsOpen: PropTypes.func
};

export default function SideBarGeofences({ setSelectedGeofenceId, setIsOpen }) {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const geofences = useSelector(selectGeofencesArray);

  const handleClickImportGeofence = async (data) => {
    const response = await createWithURLSearchParams(`geofences/import`, {
      data
    });
    if (response.ok) {
      enqueueSnackbar(t('FL_Import_Snackbar'), { variant: 'success' });
      setIsOpen(false);
    } else {
      const error = await response.text();
      const message = error.slice(0, error.indexOf('-'));
      enqueueSnackbar(message, { variant: 'error' });
    }
  };

  const fileHandler = (event) => {
    const reader = new FileReader();
    reader.readAsText(event.target.files[0]);
    reader.onload = (e) => {
      handleClickImportGeofence(e.target.result);
    };
  };

  return (
    <List
      sx={{ width: '100%', bgcolor: 'background.paper', overflow: 'auto' }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ px: 2, py: 1, bgcolor: 'background.default' }}
        >
          <Stack spacing={0.5}>
            <ListSubheader component="div" id="nested-list-subheader">
              {t('Geofences_List')}
            </ListSubheader>
          </Stack>
          <input
            accept=".xml"
            style={{ display: 'none' }}
            onChange={fileHandler}
            id="icon-button-file"
            type="file"
            multiple={false}
            value=""
          />
          <label htmlFor="icon-button-file">
            <IconButton disableRipple component="span">
              <Icon icon="ic:baseline-upload-file" />
            </IconButton>{' '}
          </label>
        </Stack>
      }
    >
      {geofences.map((geofence) => (
        <ListItem key={geofence.id} onClick={() => setSelectedGeofenceId(geofence.id)}>
          <ListItemButton>
            <ListItemText primary={geofence.name} />
          </ListItemButton>
          <IconButton
            onClick={() => {
              setSelectedGeofenceId(geofence.id);
              setIsOpen(true);
            }}
          >
            <Icon icon={editFill} width={24} height={24} />
          </IconButton>
        </ListItem>
      ))}
    </List>
  );
}
